<div class="card" [ngClass]="cardModifier()">
  <div class="card-header card-header--row">
    <div class="card-header__title">
      @if (titleKey(); as titleKey) {
        {{ titleKey | translate }}
      }
    </div>
    <div class="card-header__actions">
      <ng-content select="[cardHeaderActions]" />
    </div>
  </div>
  <div class="card-body">
    <ng-content />
  </div>
</div>
